define('views/pages/trade/offer/repeat/navbar',[
    'jquery',
    'underscore',
    'views/base/view',
    'text!templates/pages/trade/offer/repeat/navbar.ejs'
], function($, _, View, template) {
    'use strict';

    var NavbarView = View.extend({
        region: 'repeat-navbar',
        autoRender: true,
        template: template,
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            this.delegate('click', '#repeat-select-all', this.onSelectAll);
            this.delegate('click', '#repeat-clear-selection', this.onClearSelection);
        },
        onSelectAll: function() {
            this.model.request.items.each(function(model) {
                model.set('selected', true);
            });
        },
        onClearSelection: function() {
            this.model.request.items.each(function(model) {
                model.set('selected', false);
            });
        }
    });

    return NavbarView;
});

